<template>
  <article class="result" :class="result.postType">
    <div class="image" :style="{ backgroundImage: 'url(' + featuredImage + ')' }">
      <router-link :to="{name: 'Post', params: {slug: result.slug}}"></router-link>
    </div>
    <div class="content">
      <router-link :to="{name: 'Post', params: {slug: result.slug}}"><h2 v-html="result.title"></h2></router-link>
      <p class="meta">
        <span v-if="result.postType === 'extra'">Extra •</span>
        <span v-if="result.number">{{ episodeNumber }} •</span>
        <span>{{ formattedDate }}</span>
        <span v-if="resultTopics">• 
          <span v-for="(topic, index) in resultTopics">
            <router-link v-if="result.postType === 'episode'" :to="{name: 'Category', params: { topic: topic.slug }}" v-html="topic.name"></router-link>
            <router-link v-else :to="{name: 'Extras', query: { topic: topic.slug }}" v-html="topic.name"></router-link><span v-if="index + 1 !== resultTopics.length">, </span>
          </span>
        </span>
      </p>
      <p><span v-html="result.excerpt"></span> <router-link :to="{ name: 'Post', params: { slug: result.slug } }" class="more-link">More</router-link></p>
    </div>
  </article>
</template>

<script>
export default {
  name: 'search-result',
  props: ['result'],
  computed: {
    episodeNumber () {
      if (this.result.lstplus) {
        return 'LST+'
      }
      return '#' + this.result.number
    },
    formattedDate () {
      return this.$moment(this.result.date).format('MM.DD.YY')
    },
    featuredImage () {
      let vm = this
      let image = vm.result.image.large
      if (process.env.NODE_ENV === 'development') {
        image = image.replace('http://longestshortesttime.duck/app', 'http://cdn.longestshortesttime.com/wp-content')
      }
      return image
    },
    resultTopics () {
      if (this.result.topics) {
        return this.result.topics.filter((topic) => {
          return topic.name !== 'PODCAST'
        })
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
  @import ../../assets/styles/colors
  @import ../../assets/styles/mixins

  article.result
    margin-bottom: 48px
    +tablet
      display: flex
    +desktop
      padding-right: 90px
    h2
      font-size: 28px
      font-weight: bold
      margin-bottom: 0.15em
      &:hover
        color: $turqoise
    p
      font-size: 18px
      line-height: 28px
      &.meta
        font-size: 18px
        font-weight: bold
        line-height: 22px
        letter-spacing: 0.5px
        margin-bottom: 0.55em
        a
          color: inherit
          &:hover
            color: $turquoise
    .image
      margin-right: 56px
      background: $turqoise
      background-size: cover
      background-position: center center
      position: relative
      display: block
      border-top: 8px solid $turqoise
      width: 100%
      height: 0
      padding-top: 60%
      margin-bottom: 30px
      +tablet
        width: 248px
        height: 148px
        padding-top: 0
      a
        position: absolute
        top: 0
        left: 0
        right: 0
        bottom: 0
    .content
      flex: 1
    &.extra
      .image
        border-color: $yellow
        background-color: $yellow
      h2
        &:hover
          color: $yellow
      p.meta
        a:hover
          color: $yellow
</style>



// WEBPACK FOOTER //
// SearchResult.vue?1d2378f8